import axios from '../../axios'

export default {
	state: {
		messages: {},
		status: 'ready',// loading,ready,error
		display: false,
		payload: {},
		idChat: 0,
		is_chat_unread: null,
		collocutor: {},
	},
	mutations: {
		updatePayload(state, payload) {
			state.payload = payload;
		},
		updateMessages(state, messages) {
			state.status = 'ready';
			state.messages = messages;
		},
		updateIsChatUnread(state, is_chat_unread) {
			state.is_chat_unread = is_chat_unread;
		},
		addMessage(state, message) {
			state.messages.unshift(message);
		},
		messageRequest(state) {
			state.status = 'loading'
		},
		error(state) {
			state.status = 'error';
		},
		showChat(state) {
			if(state.display !== true) {
				state.display = true;
			}
		},
		setIdChat(state,id) {
			state.idChat = id
		},
		hideChat(state) {
			state.status = 'close';
			state.display = false;
		},
		updateCollocutor(state, payload) {
			state.collocutor = payload;
		}
	},
	actions: {
		async getMessages({state, commit},payload = null) {
			commit('messageRequest');

			if(payload !== null) {
				let id;

				if(payload && payload.id){
					id = (await axios.post('/chat/create',{order_id:+payload.id})).data.data.id;
				}
				else if(payload && payload.userId){
					const res = (await axios.post('/chat/create',{user_id:+payload.userId})).data.data;
					id = res.id;

					let clientData = res.client_data;
					clientData.role = "client";

					commit("updateCollocutor", clientData);
				}
				else{
					id = (await axios.post('/chat/create')).data.data.id;
					let clientData = { role: "manager" };
					commit("updateCollocutor", clientData);
				}

				commit("setIdChat", id);

				commit('showChat');
			}

			if(payload === null) {
				if(state.display !== false) {
					payload = state.payload;
				} else {
					return;
				}
			} else {
				commit("updatePayload", payload);
			}
			let id = state.idChat;

			if (!id) return false;

			await axios.post(`/chat/set-messages-viewed/${id}`);

			commit('setIdChat',id);

			return new Promise((resolve,reject)=>{
				axios.get('/chat/view/'+id)
					.then(resp=>{
					commit('updateMessages', resp.data.data);
					commit('updateIsChatUnread', resp.data.is_chat_unread);

					resolve(resp);
				}).catch(err => {
					commit('error')
					reject(err);
				})
			})
		},
		hideChat({commit}) {
			commit('hideChat');
		},
		async sendMessage({commit,state,dispatch}, message) {
			commit('messageRequest');
			if(!state.idChat) return false;
			return new Promise((resolve, reject) => {
				axios.post('/chat/send-message/'+state.idChat,{message: message.msg, asAuthor: message.asAuthor})
					.then(async resp => {
						resolve(resp);
					})
					.catch(err => {
						commit('error')
						reject(err);
					})
			})
		}
	},
	getters: {}
}
